import { RequestParams } from '@robovision/data'
import { HttpStatusCode } from '@robovision/rvai-utils'
import {
  type DataTag,
  queryOptions,
} from '@tanstack/vue-query'
import { Tag } from '~domain/Tag'
import {
  dataApi,
} from '~services/api'
import { queryClient } from '~services/query-client'
import { acceptStatus } from '~utils/api'
import { RETHROW_ERROR_AFTER_HANDLING } from '~utils/api/error-handling'


type GetTagMetadataQuery = Parameters<typeof dataApi.tags.getTagMetadata>[1]

type GetTagMetadataParams = Omit<RequestParams, 'signal' | 'validateStatus'>
  & { signal?: AbortSignal }

function getTagMetadataQueryKey (tagId: string, query: GetTagMetadataQuery = {}) {
  return ['dataApi', 'tags', 'getTagMetadata', tagId, query] as DataTag<unknown[], Tag>
}

export function getTagMetadataQueryOptions (
  tagId: string,
  query?: GetTagMetadataQuery,
  params?: GetTagMetadataParams,
) {
  return queryOptions({
    queryFn: ({ signal }) => dataApi.tags.getTagMetadata(tagId, query, {
      ...RETHROW_ERROR_AFTER_HANDLING,
      ...params,
      signal: params?.signal ? AbortSignal.any([signal, params.signal]) : signal,
      validateStatus: acceptStatus(HttpStatusCode.NOT_FOUND),
    })
      .then(response => response.status === HttpStatusCode.NOT_FOUND
        ? null
        : Tag.fromResponse(response.data)),
    queryKey: getTagMetadataQueryKey(tagId, query),
  })
}

export function getTagMetadata (
  tagId: string,
  query?: GetTagMetadataQuery,
  params?: GetTagMetadataParams,
) {
  return queryClient.fetchQuery(getTagMetadataQueryOptions(tagId, query, params))
}
